import React from "react"
import { Box } from "@chakra-ui/react"
import Link from "components/elements/Link"
import { ButtonBlock } from "sharedTypes/builder"
import { buttonStyles } from "components/Builder/buttonStyles"

const Button = ({ block: { data } }: { block: ButtonBlock }) => {
  const styles = buttonStyles(data)

  return (
    <Box
      textAlign="center"
      bgColor={data.blockColor}
      pt={`${data.paddingTop * 4}px`}
      pb={`${data.paddingBottom * 4}px`}
    >
      <Link
        bgColor={data.buttonColor}
        color={data.textColor}
        fontFamily={data.font}
        fontSize={styles.fontSize}
        fontWeight={styles.fontWeight}
        display="inline-block"
        pt={styles.paddingTop}
        pb={styles.paddingBottom}
        pl={styles.paddingLeft}
        pr={styles.paddingRight}
        textDecoration="none"
        borderRadius={styles.borderRadius}
        cursor="pointer"
        transition="filter 0.2s"
        _hover={{ filter: "brightness(0.9)" }}
      >{data.text}
      </Link>
    </Box>
  )
}

export default Button
